import logger from '../../services/logger';

import React, { useState} from 'react';
import CameraCapture from './CameraCapture'; // Assurez-vous que le chemin d'importation est correct

import {Button } from "react-bootstrap"; 
import { FileIcon } from './Icon';


const ImageUploader = ({onImageUpload }) => {
  
  const [selectedImage, setSelectedImage] = useState(null);
  const [urlSelectedImage, setURLSelectedImage] = useState(null);
  const [useCamera, setUseCamera] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const fileInputRef = React.createRef(); 


  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const url = URL.createObjectURL(file)
      setSelectedImage(file); // Met à jour l'image sélectionnée
      setURLSelectedImage(url);
      onImageUpload(url, file); // Appeler onImageUpload après la mise à jour
    }
  };

  const handleUseCamera = (e) => {
    setUseCamera(true)
    setSelectedImage(null);
    setURLSelectedImage(null);
    onImageUpload(null,null);
  };

  const handleCapture = (blob) => {
    const imgFile = new File([blob], "captured_image.jpg", { type: "image/jpeg", lastModified: new Date() });
    setSelectedImage(imgFile);
    logger.log("image captured ", imgFile);
    const url = URL.createObjectURL(imgFile)
    onImageUpload(url,imgFile ); // Appeler onImageUpload après la mise à jour
    setUseCamera(false); // Cachez la caméra après la capture
  };

  const closeCapture = () => {
    setUseCamera(false)
  };

  const handleOpenPreview = () => {
    if (selectedImage?.type.startsWith('image/')) {
      setIsPreviewOpen(true);
    }
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
  };

  return (
    <div className="mt-3 mb-3 text-small" >
      {useCamera ? (
        <CameraCapture
          onCapture={handleCapture}
          onClose={closeCapture}
          aria-label="Caméra activée pour capturer une image"
        />
      ) : (
        <form className="p-2 light-green-background" aria-label="Formulaire de téléchargement de fichier">
          <div >
            <div className='mt-4 mb-4 text-medium text-center'>Upload ton image</div>
            {urlSelectedImage && (
              <div
                className="mb-4"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                aria-live="polite"
                aria-describedby="selected-file-description"
              >
                {selectedImage?.type.startsWith('image/') ? (
                  <img
                    src={urlSelectedImage}
                    alt="Prévisualisation de l'image sélectionnée"
                    onClick={handleOpenPreview}
                    style={{
                      width: 'auto',
                      maxWidth: '100%',
                      maxHeight: '120px',
                      margin: '0 auto',
                      objectFit: 'contain',
                      cursor: 'zoom-in',
                    }}
                  />
                ) : (
                  <div style={{ textAlign: 'center' }}>
                    <span
                      style={{ fontSize: '2rem', display: 'block' }}
                      role="img"
                      aria-label="Icône de fichier non image"
                    >
                      <FileIcon/>
                    </span>
                    <span id="selected-file-description">
                      {selectedImage?.name}
                    </span>
                  </div>
                )}
              </div>
            )}
  
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageChange}
              accept="image/*,application/pdf"
              style={{ display: 'none' }}
              id="file-upload"
              aria-labelledby="file-upload-label"
            />
            <div className="row mt-4 mb-4 gx-2" style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
              <div className="col-6 col-md-3 mb-2 mb-md-0">
                <Button
                  className="w-100 btn btn-secondary"
                  onClick={() => fileInputRef.current.click()}
                  aria-labelledby="file-upload-label"
                >
                  Fichier
                </Button>
              </div>
              <div className="col-6 col-md-3">
                <Button
                  className="w-100 btn btn-secondary"
                  onClick={handleUseCamera}
                  aria-label="Activer la caméra pour capturer une image"
                >
                  Caméra
                </Button>
              </div>
            </div>
          </div>
        </form>
      )}
      {isPreviewOpen && (
        <div
          onClick={handleClosePreview}
          role="dialog"
          aria-modal="true"
          aria-label="Apercu image"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1400,
            padding: '16px',
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              position: 'relative',
            }}
          >
            <button
              type="button"
              onClick={handleClosePreview}
              aria-label="Fermer l'aperçu"
              style={{
                position: 'absolute',
                top: '-12px',
                right: '-12px',
                border: 'none',
                background: '#fff',
                color: '#1f2937',
                borderRadius: '999px',
                width: '32px',
                height: '32px',
                cursor: 'pointer',
                fontSize: '18px',
              }}
            >
              ×
            </button>
            <img
              src={urlSelectedImage}
              alt="Apercu grand format"
              style={{
                width: '100%',
                height: '100%',
                maxWidth: '90vw',
                maxHeight: '90vh',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
  
}

export default ImageUploader;
